import Dialog from '@material-ui/core/Dialog';
import T from 'prop-types';
import React from 'react';
import DialogContainer from 'components/DialogContainer/styles';
import DialogTitle from 'components/DialogTitle/styles';
import {DialogBody, DialogText} from 'routes/App/dashboard/styles';
import DialogActions from 'components/DialogActions/styles';
import DialogAction from 'components/DialogAction/styles';
import {ButtonPrimary} from 'components/buttons';

const InfoModal = ({openModal, onClose}) => {
  return (
    <Dialog open={openModal}>
      <DialogContainer className='DialogSm'>
        <DialogTitle className='DialogTitleMarginBottom verticalCenter'>
          Not supported for this order provider
        </DialogTitle>
        <DialogBody>
          <DialogText>
            Contact support or login to provider platform to perform this action
          </DialogText>
          <DialogActions className='justifyCenter'>
            <DialogAction className='DialogActions w50'>
              <ButtonPrimary onClick={onClose}>
                <span>Ok</span>
              </ButtonPrimary>
            </DialogAction>
          </DialogActions>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

InfoModal.propTypes = {
  openModal: T.bool.isRequired,
  onClose: T.func.isRequired
};

export default InfoModal;
